var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-main"},[_c('p',{staticStyle:{"padding":"30px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.onClear}},[_vm._v("삭제")])])])}
var staticRenderFns = []

export { render, staticRenderFns }